import React from "react";
import { useKycVideoVerification } from "./hooks/useKycVideoVerification";
import KycElectronicID from "../KycAutomatic/shared/steps/KycElectronicId";
import RetryElectronicId from "../KycAutomatic/shared/components/RetryElectronicId";
import Text from "../../../shared/components/Text";

export default function KycVideoVerification({ allowedLenders }) {
  const {
    electronicIdSubmitted,
    onSubmitKycElectronicId,
    setElectronicIdSubmitted,
  } = useKycVideoVerification({ allowedLenders });

  return (
    <>
      {!electronicIdSubmitted && (
        <KycElectronicID
          onSubmitForm={onSubmitKycElectronicId}
          disableKycManual={true}
          allowInternationalBorrower={false}
          contextMessage={<Text tId="KYC_VIDEO_VERIFICATION_CONTEXT" />}
        />
      )}
      <RetryElectronicId
        onRetryElectronicId={() => setElectronicIdSubmitted(false)}
      />
    </>
  );
}
